module.exports = __webpack_public_path__ + "static/media/0252_Small.69297e4a.jpg";